import { Button } from "@veneer/core";
import styled from "styled-components";
import { spacing } from "@clientos/ui-toolkit";
import tokens from "@veneer/tokens";

export const ButtonEasyStartModify = styled(Button)`
  color: #024AD8 !important;
  border-color: #024AD8 !important;
`;

export const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: #FFFFFF;
  
  @media (max-width: 604px) {
    padding: ${spacing.space_s};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 700px;
  padding: ${spacing.space_2xl} ${spacing.space_3xl};
  background: #FFFFFF;
  
  @media (max-width: 604px) {
    max-width: 100%;
    padding: ${spacing.space_l};
  }
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 604px;
  
  @media (max-width: 604px) {
    max-width: 100%;
  }
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space_m};
  margin-bottom: ${spacing.space_2xl};
`;

export const Title = styled.div`
  margin: 0;
  color: #1A1A1A;
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  font-size: ${tokens.layout.size8};
  font-weight: 500;
  
  @media (max-width: 627px) {
    font-size: ${tokens.layout.size6};
  }
`;

export const BodyText = styled.div`
  color: #1A1A1A;
  font-family: "Forma DJR UI", "HP Simplified", sans-serif;
  
  p {
    margin: 0;
    
    &:not(:last-child) {
      margin-bottom: ${spacing.space_s};
    }
  }
  
  a {
    color: ${tokens.color.royalBlue7};
    text-decoration: underline;
    
    &:hover {
      color: ${tokens.color.royalBlue8};
    }
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${spacing.space_sm};
  justify-content: flex-end;
  
  @media (max-width: ${tokens.layout.smMin}) {
    flex-direction: column;
    gap: ${spacing.space_s};
    
    button {
      width: 100%;
    }
  }
`;
